<template>
  <div class="pic-word-box">
    <div class="box">
      <!-- 多图文 -->
      <ex-picwordfirst :info="list[0]" v-if="list.length>1"></ex-picwordfirst>
      <ex-picword v-for="(item, index) in list" :key="index" :info="item" v-if="index>0"></ex-picword>
      <!-- 单图文 -->
      <ex-picwordone :info="list[0]" v-if="list.length==1"></ex-picwordone>
    </div>
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    list: { type: Array, default: [] }
  },
  data() {
    return {
    };
  },
  methods: {
  }
};
</script>
